import { AbstractControl, ValidatorFn } from '@angular/forms';

import { ZIP_CODE_BY_COUNTRY_REGEX } from 'src/app/shared/enums/zip.enums';
import { isString } from 'lodash-es';

export function zipCodeValidator(requiredCountry?: string): ValidatorFn {
	function zipCodeValidatorFn(control: AbstractControl): { zipCode: boolean; match?: boolean } | null {
		const { value } = control;
		const trimedValue = isString(value) ? value.trim() : '';
		const regexp = ZIP_CODE_BY_COUNTRY_REGEX[requiredCountry] || ZIP_CODE_BY_COUNTRY_REGEX.INTL;
		const isValidZip = regexp.test(trimedValue);

		if (!isValidZip) {
			return {
				match: false,
				zipCode: true,
			};
		}

		return null;
	}

	zipCodeValidatorFn.isZipCodeValidator = true;

	return zipCodeValidatorFn;
}
